// General
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

// Constants
import { CREATE_PASSWORD_START, CREATE_PASSWORD_SUCCESS, CREATE_PASSWORD_ERROR } from '../../constants';

// Redux Form
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import { graphql, gql, compose } from 'react-apollo';

// Locale
import messages from '../../locale/messages';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './CreatePassword.css';
import bt from '../../components/commonStyle.css';
import {
  Button,
  Form,
  Row,
  Col,
  FormControl
} from 'react-bootstrap';

const validatePassword = (values) => {
  const errors = {}

  if (!values.password) {
    errors.password = messages.required;
  } else if (values.newPassword.length < 8) {
    errors.password = messages.passwordError3;
  }

  return errors
}

class CreatePassword extends Component {

  constructor(props) {
    super(props);

    this.state = {passwordCreated: false};

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className, isDisabled }) => {
    const { formatMessage } = this.props.intl;
    return (
      <React.Fragment>
        <FormControl {...input} placeholder={label} type={type} className={className} disabled={isDisabled} />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </React.Fragment>
    )
  }

  async handleSubmit(values, dispatch) {
    const query = `
      mutation (
          $oldPassword: String,
          $newPassword: String,
          $confirmPassword: String
      ) {
          ChangePassword (
              oldPassword: $oldPassword,
              newPassword: $newPassword,
              confirmPassword: $confirmPassword
          ) {
              status
          }
      }
    `;

    dispatch({type: CREATE_PASSWORD_START});

    const resp = await fetch('/graphql', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        query: query,
        variables: {
          oldPassword: '',
          newPassword: values.password,
          confirmPassword: values.password
        }
      }),
      credentials: 'include',
    });

    const { data } = await resp.json();

    if( data && data.ChangePassword && data.ChangePassword.status === 'success' ) {
      dispatch({type: CREATE_PASSWORD_SUCCESS});
      this.state.passwordCreated = true;
    }
    else {
      dispatch({type: CREATE_PASSWORD_ERROR});
    }
  }

  render() {
    const { error, handleSubmit, submitting } = this.props;
    const { formatMessage } = this.props.intl;
    const { passwordCreated } = this.state;

    return (
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className={cx(s.space7, s.positionRelative)}>
            {
              !passwordCreated ? <Form onSubmit={handleSubmit(this.handleSubmit)}><label className={cx(bt.inputLabelText, s.inputLabelTextLeft)}>{formatMessage(messages.createPassword)}</label>
              <Field name="password"
                type="password"
                component={this.renderFormControl}
                label={formatMessage(messages.createPassword)}
                className={cx(bt.commonControlInput, s.passwordInput)}
              />
              <Button bsSize="small" className={cx(bt.continueBtnListing, s.btnWidth)} type="submit" disabled={submitting}>
                {formatMessage(messages.save)}
              </Button>
              {
                error && <span className={s.errorMessage}>{formatMessage(error)}</span>
              }
              {
                //#region Attempt to use Bootstrap InputGroup and InputGroup.Button
                /*
                <FormGroup>
                  <InputGroup>
                    <label className={cx(bt.inputLabelText, s.inputLabelTextLeft)}>{formatMessage(messages.createPassword)}</label>
                    <Field name="password"
                      type="password"
                      component={this.renderFormControl}
                      label={formatMessage(messages.createPassword)}
                      className={cx(bt.commonControlInput, s.firstNameWidth)}
                    />
                    <InputGroup.Button>
                      <Button bsSize="small" className={cx(bt.continueBtnListing, s.btnWidth)} type="submit" disabled={submitting}>
                        {formatMessage(messages.save)}
                      </Button>
                    </InputGroup.Button>
                    {
                      error && <span className={s.errorMessage}>{formatMessage(error)}</span>
                    }
                  </InputGroup>
                </FormGroup>
                */
                //#endregion
              }
              </Form>
              :
              <span><FormattedMessage {...messages.passwordCreated} /> <a href="/user/edit"><FormattedMessage {...messages.completeProfile} /></a></span>
            }
          </div>
        </Col>
      </Row>
    )
  }

}

CreatePassword = reduxForm({
  form: 'CreatePassword', // a unique name for this form
  validatePassword,
})(CreatePassword);

//const selector = formValueSelector('CreatePassword');

const mapState = (state) => ({});
const mapDispatch = {};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch)
)(CreatePassword);


// WEBPACK FOOTER //
// src/components/Itinerary/CreatePassword.js